import Cookies from 'js-cookie';
import { PASSWORD_TOKEN } from './userStorageConstants';

export function getPasswordToken() {
    return Cookies.get(PASSWORD_TOKEN);
}

export function removePasswordToken() {
    Cookies.remove(PASSWORD_TOKEN);
}
